import React from 'react';
import { Construction } from 'lucide-react';

interface ComingSoonProps {
  title?: string;
  description?: string;
  className?: string;
}

export function ComingSoon({ 
  title = 'Coming Soon', 
  description = 'This feature is currently under development.',
  className = ''
}: ComingSoonProps) {
  return (
    <div className={`relative group ${className}`}>
      <div className="absolute inset-0 bg-gradient-to-r from-[#5e9bb8]/10 to-[#499da8]/10 rounded-xl transform group-hover:scale-105 transition-all duration-300"></div>
      <div className="relative bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm p-6 rounded-xl border border-[#5e9bb8]/20 dark:border-[#5e9bb8]/10 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
        <div className="flex items-center justify-center mb-4">
          <Construction className="h-12 w-12 text-[#5e9bb8] animate-bounce" />
        </div>
        <h3 className="text-xl font-semibold text-center bg-clip-text text-transparent bg-gradient-to-r from-[#5e9bb8] to-[#499da8] mb-2">
          {title}
        </h3>
        <p className="text-gray-600 dark:text-gray-300 text-center text-sm">
          {description}
        </p>
      </div>
    </div>
  );
}